import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatListModule } from '@angular/material/list';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatSelectModule } from '@angular/material/select';
import { MatTableModule } from '@angular/material/table';
import { MatTooltipModule } from '@angular/material/tooltip';
import { RouterModule, Routes } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { ReferenceSizePage } from './reference-size.page';
import { ReferenceSizeDialogModule } from './reference-size-dialog/reference-size-dialog.module';
import { MatSortModule } from '@angular/material/sort';

export * from './reference-size.page';
export * from './reference-size-dialog/reference-size-dialog.module';

const routes: Routes = [
    {
        path: '',
        component: ReferenceSizePage,
    },
];

@NgModule({
    declarations: [ ReferenceSizePage ],
    imports: [
        CommonModule,
        RouterModule.forChild(routes),
        MatCardModule,
        MatInputModule,
        MatIconModule,
        FormsModule,
        TranslateModule,
        MatListModule,
        MatTableModule,
        MatButtonModule,
        MatSelectModule,
        MatPaginatorModule,
        ReferenceSizeDialogModule,
        MatProgressBarModule,
        MatTooltipModule,
        MatSortModule,
    ],
})
export class ReferenceSizePageModule {
}
